import React, { Suspense } from 'react'
import {
  Navigate,
  Route,
  Routes
} from 'react-router-dom'
import { CContainer } from 'compat/coreui'

// routes config
import routes from '../../routes'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// paths in routes.js are absolute (/dashboard/...); this component renders
// inside the /dashboard/* route, so match on the remainder of the path
const relativePath = (path) => {
  const rest = path.replace(/^\/dashboard\/?/, '')
  return rest === '' ? '/' : rest
}

const TheContent = () => {
  return (
    <main className="c-main">
      <CContainer fluid>
        <Suspense fallback={loading}>
          <Routes>
            {routes.map((route, idx) => {
              return route.component && (
                <Route
                  key={idx}
                  path={route.path.startsWith('/dashboard') ? relativePath(route.path) : route.path}
                  element={<route.component />} />
              )
            })}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Suspense>
      </CContainer>
    </main>
  )
}

export default TheContent
